/**
 * Visual style for each `tilstand` (condition) value.
 *
 * The condition badge on ListingCard (and other places that surface a
 * condition tag in the future) tints itself per value so a quick glance
 * tells the user how worn an item is. Colors are intentionally muted to
 * sit well alongside the brand-neutral product photography.
 *
 * Keys must match the `option` values defined for the `tilstand` listing
 * field in `src/config/configListing.js`.
 */
export const conditionStyles = {
  // New with tags — freshest, leans green
  'ny-med-merkelapp': { backgroundColor: '#e8f4ed', color: '#2e6e4e' },
  // Like new — clean, leans blue
  'som-ny': { backgroundColor: '#e6eef6', color: '#3a5e87' },
  // Gently used — warm beige, lived-in
  'pent-brukt': { backgroundColor: '#f0ebe1', color: '#7a5d3b' },
  // Good condition — warmest, terra
  'god-stand': { backgroundColor: '#f6e6e0', color: '#8a4a35' },
};

/**
 * Return the inline-style object for a condition key, or `null` when the
 * key isn't recognized (so the consumer can fall back to its default
 * stylesheet rules).
 *
 * @param {string} conditionKey
 * @returns {{backgroundColor: string, color: string} | null}
 */
export const getConditionStyle = conditionKey =>
  conditionKey ? conditionStyles[conditionKey] || null : null;
